export class Autocomplete {
    constructor(inputId, resultsId, searchUrl = null, useMockData = false, hiddenInputId = null, isMultiselect = false, persistentDropdown = false, forceSingleSelect = false, simpleDropdown = false) {
        this.input = document.getElementById(inputId);
        this.resultsContainer = document.getElementById(resultsId);
        this.hiddenInput = hiddenInputId ? document.getElementById(hiddenInputId) : null;

        // Get search URL from HTML data attribute if not provided
        this.searchUrl = searchUrl || this.input.dataset.searchUrl || null;
        // console.log(this.searchUrl);
        // console.log('Search-url:'+this.searchUrl);

        // If no search URL provided, automatically use mock data or simple dropdown
        if (!this.searchUrl) {
            if (!simpleDropdown) {

                this.useMockData = true;
                // console.info('No search URL provided, using mock data');
            } else {
                this.useMockData = false;
            }
        } else {
            this.useMockData = useMockData;
        }

        // console.log(this.useMockData);

        this.currentFocus = -1;
        this.debounceTimer = null;
        this.minChars = simpleDropdown ? 0 : 2;
        this.debounceDelay = 300;
        this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || window.innerWidth <= 768;
        this.touchStartY = 0;
        this.backdrop = null;
        this.mobileHeader = null;
        this.mobileWrapper = null;
        this.mobileResultsContainer = null;
        this.originalResultsContainer = this.resultsContainer;
        this.mobileUICreated = false;
        this.mobileSearchInput = null;
        this.isMultiselect = isMultiselect;
        this.persistentDropdown = persistentDropdown;
        this.forceSingleSelect = forceSingleSelect;
        this.selectedItems = [];
        this.selectedContainer = null;
        this.inlineSelectedContainer = null;
        this.selectedCollapsed = false;
        this.prefilledOptions = null;
        this.hasUserTyped = false;
        this.mobileResultsShown = false;
        this.simpleDropdown = simpleDropdown;
        this.localOptions = [];
        this.lastSelectedValue = null;
        this.lastSelectedLabel = null;
        this.dropdownWasOpenedForSelection = false;

        // Text configuration with Romanian defaults
        this.texts = {
            selectOption: this.input.dataset.textSelectOption || 'Selectează o opțiune',
            search: this.input.dataset.textSearch || 'Caută...',
            noResults: this.input.dataset.textNoResults || 'Nu s-au găsit rezultate',
            errorLoading: this.input.dataset.textErrorLoading || 'Eroare la încărcarea rezultatelor',
            close: this.input.dataset.textClose || 'Închide',
            mobileTitle: this.input.dataset.textMobileTitle || 'Selectează o opțiune'
        };

        // Check for prefilled options in the results container
        if (this.resultsContainer.dataset.prefilledOptions) {
            try {
                this.prefilledOptions = JSON.parse(this.resultsContainer.dataset.prefilledOptions);
            } catch (e) {
                console.error('Error parsing prefilled options:', e);
            }
        }

        // If simple dropdown mode, load options from HTML
        if (this.simpleDropdown) {
            this.loadOptionsFromHTML();
        }

        if (this.isMultiselect) {
            this.setupMultiselect();
        }

        // Initialize with preselected values if provided
        this.initializePreselectedValues();

        // Mock data with categories for testing
        this.mockData = [
            {id: 1, name: 'Apple', category: 'Popular Fruits'},
            {id: 2, name: 'Banana', category: 'Popular Fruits'},
            {id: 3, name: 'Orange', category: 'Popular Fruits'},
            {id: 4, name: 'Strawberry', category: 'Popular Fruits'},
            {id: 5, name: 'Cherry', category: 'Berries'},
            {id: 6, name: 'Raspberry', category: 'Berries'},
            {id: 7, name: 'Elderberry', category: 'Berries'},
            {id: 8, name: 'Date', category: 'Tropical Fruits'},
            {id: 9, name: 'Fig', category: 'Tropical Fruits'},
            {id: 10, name: 'Mango', category: 'Tropical Fruits'},
            {id: 11, name: 'Papaya', category: 'Tropical Fruits'},
            {id: 12, name: 'Jackfruit', category: 'Tropical Fruits'},
            {id: 13, name: 'Grape', category: 'Vine Fruits'},
            {id: 14, name: 'Honeydew', category: 'Melons'},
            {id: 15, name: 'Watermelon', category: 'Melons'},
            {id: 16, name: 'Kiwi', category: 'Exotic Fruits'},
            {id: 17, name: 'Lemon', category: 'Citrus Fruits'},
            {id: 18, name: 'Tangerine', category: 'Citrus Fruits'},
            {id: 19, name: 'Nectarine', category: 'Stone Fruits'},
            {id: 20, name: 'Quince', category: 'Other Fruits'}
        ];

        this.init();
    }

    initializePreselectedValues() {
        // Check for preselected value(s) from different sources

        // For multiselect, check for multiple hidden inputs with array notation
        if (this.isMultiselect && this.hiddenInput) {
            const hiddenInputName = this.hiddenInput.name || this.hiddenInput.id;
            const multipleInputs = document.querySelectorAll(`input[name="${hiddenInputName}[]"]`);

            if (multipleInputs.length > 0) {
                // Multiple hidden inputs found - use these for preselected values
                this.preselectedValuesWithLabels = [];
                multipleInputs.forEach(input => {
                    const value = input.value || input.dataset.selected;
                    const label = input.dataset.selectedLabel || value;
                    if (value) {
                        this.preselectedValuesWithLabels.push({ value, label });
                    }
                });
            } else if (this.hiddenInput.value) {
                // Single hidden input with multiple values
                const initialValue = this.hiddenInput.value;

                // Check if it's a JSON array or comma-separated
                try {
                    const values = JSON.parse(initialValue);
                    if (Array.isArray(values)) {
                        this.preselectedValues = values;
                    }
                } catch (e) {
                    // Not JSON, try comma-separated
                    if (initialValue.includes(',')) {
                        this.preselectedValues = initialValue.split(',').map(v => v.trim());
                    } else {
                        this.preselectedValues = [initialValue];
                    }
                }
            }
        } else if (this.hiddenInput && this.hiddenInput.value) {
            // Single select - check hidden input for initial value
            this.preselectedValue = this.hiddenInput.value;
        }

        // 2. Check for data-selected attribute on input
        if (this.input.dataset.selected) {
            if (this.isMultiselect) {
                try {
                    this.preselectedValues = JSON.parse(this.input.dataset.selected);
                } catch (e) {
                    this.preselectedValues = [this.input.dataset.selected];
                }
            } else {
                this.preselectedValue = this.input.dataset.selected;
            }
        }

        // 3. Check for data-selected-label for display text
        if (this.input.dataset.selectedLabel) {
            this.preselectedLabel = this.input.dataset.selectedLabel;
        }

        // Apply preselected values after initialization
        if (this.simpleDropdown || this.prefilledOptions || this.localOptions.length > 0) {
            setTimeout(() => this.applyPreselectedValues(), 100);
        }
    }

    applyPreselectedValues() {
        if (this.isMultiselect && this.preselectedValuesWithLabels) {
            // For multiselect with labels already provided
            this.preselectedValuesWithLabels.forEach(item => {
                this.addSelectedItem(item.value, item.label);
            });
        } else if (this.isMultiselect && this.preselectedValues) {
            // For multiselect, add each preselected value
            this.preselectedValues.forEach(value => {
                // Find the label from options
                let label = value; // Default to value if label not found

                // Search in local options first
                if (this.localOptions.length > 0) {
                    const option = this.localOptions.find(opt => opt.id == value);
                    if (option) {
                        label = option.name;
                    }
                } else if (this.prefilledOptions) {
                    const option = this.prefilledOptions.find(opt => opt.id == value);
                    if (option) {
                        label = option.name;
                    }
                } else if (this.mockData) {
                    const option = this.mockData.find(opt => opt.id == value);
                    if (option) {
                        label = option.name;
                    }
                }

                // Add to selected items
                this.addSelectedItem(value, label);
            });
        } else if (this.preselectedValue) {
            // For single select, set the value and label
            let label = this.preselectedLabel || this.preselectedValue;

            // If no label provided, try to find it from options
            if (!this.preselectedLabel) {
                if (this.localOptions.length > 0) {
                    const option = this.localOptions.find(opt => opt.id == this.preselectedValue);
                    if (option) {
                        label = option.name;
                    }
                } else if (this.prefilledOptions) {
                    const option = this.prefilledOptions.find(opt => opt.id == this.preselectedValue);
                    if (option) {
                        label = option.name;
                    }
                }
            }

            // Set the display value
            this.input.value = label;

            // Update stored values for simple dropdown
            if (this.simpleDropdown) {
                this.lastSelectedValue = this.preselectedValue;
                this.lastSelectedLabel = label;
            }

            // Ensure hidden input has the value
            if (this.hiddenInput) {
                this.hiddenInput.value = this.preselectedValue;
                this.hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }
    }

    loadOptionsFromHTML() {
        // Try to find options from different sources

        // 1. Check for a select element with matching ID pattern
        const selectElement = document.querySelector(`select[data-autocomplete="${this.input.id}"]`);
        if (selectElement) {
            const options = selectElement.querySelectorAll('option');
            options.forEach(option => {
                if (option.value) {
                    this.localOptions.push({
                        id: option.value,
                        name: option.textContent.trim(),
                        category: option.dataset.category || 'Options',
                        selected: option.selected // Capture if option is selected
                    });

                    // If option is selected and we don't have preselected values yet
                    if (option.selected && !this.preselectedValue && !this.preselectedValues) {
                        if (this.isMultiselect) {
                            if (!this.preselectedValues) this.preselectedValues = [];
                            this.preselectedValues.push(option.value);
                        } else {
                            this.preselectedValue = option.value;
                            this.preselectedLabel = option.textContent.trim();
                        }
                    }
                }
            });
            // Hide the original select element
            selectElement.style.display = 'none';
        }

        // 2. Check for options in data attribute
        if (this.localOptions.length === 0 && this.input.dataset.options) {
            try {
                this.localOptions = JSON.parse(this.input.dataset.options);
            } catch (e) {
                console.error('Error parsing options from data attribute:', e);
            }
        }

        // 3. Use prefilled options if available
        if (this.localOptions.length === 0 && this.prefilledOptions) {
            this.localOptions = this.prefilledOptions;
        }

        // Ensure all options have required properties
        this.localOptions = this.localOptions.map(option => ({
            id: option.id || option.value,
            name: option.name || option.label || option.text,
            category: option.category || ' '
        }));
    }

    init() {
        this.input.addEventListener('input', (e) => this.handleInput(e));
        this.input.addEventListener('keydown', (e) => this.handleKeydown(e));
        this.input.addEventListener('focus', (e) => this.handleFocus(e));
        
        // On mobile, make input readonly to prevent keyboard
        if (this.isMobile) {
            this.input.setAttribute('readonly', 'readonly');
            this.input.style.cursor = 'pointer';
        }

        // In simple dropdown mode OR single select (including forceSingleSelect), add click handler
        if (this.simpleDropdown || (!this.isMultiselect && !this.persistentDropdown) || (this.isMultiselect && this.forceSingleSelect)) {
            this.input.addEventListener('click', (e) => {
                if (this.simpleDropdown) {
                    this.handleSimpleDropdownClick(e);
                } else {
                    this.handleSingleSelectClick(e);
                }
            });
            // Allow typing for filtering (except on mobile where we prevent keyboard)
            if (!this.isMobile) {
                this.input.style.cursor = 'text';
            }
        }

        document.addEventListener('click', (e) => this.handleClickOutside(e));

        // Mobile-specific events
        if (this.isMobile) {
            this.resultsContainer.addEventListener('touchstart', (e) => this.handleResultsTouchStart(e), { passive: true });
            this.resultsContainer.addEventListener('touchmove', (e) => this.handleResultsTouchMove(e), { passive: false });
        }
    }

    handleFocus(e) {
        // Don't re-trigger if mobile UI is already open, UNLESS it's persistent dropdown
        if (this.isMobile && this.mobileUICreated && !this.persistentDropdown) {
            return;
        }

        const value = e.target.value;

        // Simple dropdown mode - show all options on focus
        if (this.simpleDropdown) {
            // Only store and clear if not already opened
            if (!this.dropdownWasOpenedForSelection) {
                this.storeCurrentValue();
                this.dropdownWasOpenedForSelection = true;
            }

            // If there's a value but dropdown is opening, don't clear yet
            // Let user see current value and type to filter
            if (value.length === 0 || !this.hasUserTyped) {
                this.displayResults(this.localOptions);
            }
            return;
        }

        if (this.isMobile) {
            // Mobile behavior - trigger mobile UI but don't show results yet
            if (value.length === 0 && !this.mobileResultsShown) {
                // This will create mobile UI and show prefilled options after animation
                this.displayResults(this.prefilledOptions || []);
                this.mobileResultsShown = true;
            }
        } else {
            // Desktop behavior only
            if (this.prefilledOptions && !this.hasUserTyped && value.length === 0) {
                this.displayResults(this.prefilledOptions);
            } else if (value.length === 0 && !this.simpleDropdown) {
                // Only fetch if not simple dropdown
                this.fetchResults('');
            }
        }

        // Scroll input into view on mobile
        if (this.isMobile && !this.mobileUICreated) {
            setTimeout(() => {
                this.input.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 300);
        }
    }

    handleInput(e) {
        const value = e.target.value;

        // Mark that user has typed
        this.hasUserTyped = true;

        // Simple dropdown mode - filter locally
        if (this.simpleDropdown) {
            // Mark that dropdown is open for selection
            if (!this.dropdownWasOpenedForSelection) {
                this.storeCurrentValue();
                this.dropdownWasOpenedForSelection = true;
            }

            // Allow filtering while typing
            if (value.length === 0) {
                // Show all options when input is cleared
                this.displayResults(this.localOptions);
            } else {
                // Filter options based on input
                const filtered = this.filterLocalOptions(value);
                this.displayResults(filtered);
            }
            return;
        }

        clearTimeout(this.debounceTimer);

        if (value.length === 0) {
            // If user clears input, show prefilled options if available
            if (this.prefilledOptions) {
                this.displayResults(this.prefilledOptions);
            } else if (!this.simpleDropdown) {
                // Only fetch if not simple dropdown mode
                this.fetchResults('');
            }
            return;
        }

        if (value.length < this.minChars) {
            this.closeAllLists();
            return;
        }

        this.debounceTimer = setTimeout(() => {
            this.fetchResults(value);
        }, this.debounceDelay);
    }

    filterLocalOptions(searchTerm) {
        if (!searchTerm) return this.localOptions;

        const term = searchTerm.toLowerCase();
        return this.localOptions.filter(option =>
            option.name.toLowerCase().includes(term)
        );
    }

    handleSimpleDropdownClick(e) {
        // If already showing results, don't re-trigger
        if (this.resultsContainer.innerHTML.trim() && this.resultsContainer.classList.contains('show')) {
            return;
        }

        // Store current value only if not already stored
        if (!this.dropdownWasOpenedForSelection) {
            this.storeCurrentValue();
            this.dropdownWasOpenedForSelection = true;
        }

        // Show all options without clearing input (let user type to filter)
        this.displayResults(this.localOptions);

        // Select all text for easy replacement (desktop only)
        if (this.input.value && !this.isMobile) {
            this.input.select();
        }
    }

    handleSingleSelectClick(e) {
        // Similar behavior for regular single select autocomplete
        // If already showing results, don't re-trigger
        if (this.resultsContainer.innerHTML.trim() && this.resultsContainer.classList.contains('show')) {
            return;
        }

        // Store current value only if not already stored
        if (!this.dropdownWasOpenedForSelection) {
            this.lastSelectedValue = this.hiddenInput ? this.hiddenInput.value : null;
            this.lastSelectedLabel = this.input.value || null;
            this.dropdownWasOpenedForSelection = true;
        }

        // Trigger search with empty term to show all/prefilled options
        if (this.prefilledOptions) {
            this.displayResults(this.prefilledOptions);
        } else {
            this.fetchResults('');
        }

        // Select all text for easy replacement (desktop only)
        if (this.input.value && !this.isMobile) {
            this.input.select();
        }
    }

    storeCurrentValue() {
        if (this.simpleDropdown) {
            this.lastSelectedValue = this.hiddenInput ? this.hiddenInput.value : null;
            this.lastSelectedLabel = this.input.value || null;
        }
    }

    restorePreviousValue() {
        // Works for simple dropdown, single select, and forceSingleSelect
        if ((this.simpleDropdown || !this.isMultiselect || this.forceSingleSelect) && this.lastSelectedLabel) {
            this.input.value = this.lastSelectedLabel;
            if (this.hiddenInput && this.lastSelectedValue) {
                this.hiddenInput.value = this.lastSelectedValue;
                this.hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
        } else if (this.simpleDropdown || !this.isMultiselect || this.forceSingleSelect) {
            // If no previous value, clear everything
            this.input.value = '';
            if (this.hiddenInput) {
                this.hiddenInput.value = '';
                this.hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }
    }

    async fetchResults(searchTerm) {
        try {
            let data;

            if (this.useMockData || !this.searchUrl) {
                console.log('In search');

                // Simulate PHP response with mock data
                await new Promise(resolve => setTimeout(resolve, 100)); // Simulate network delay

                if (searchTerm === '') {
                    // Return first 10 items when empty
                    data = this.mockData.slice(0, 10);
                } else {
                    // Filter results based on search term
                    data = this.mockData.filter(item =>
                        item.name.toLowerCase().includes(searchTerm.toLowerCase())
                    ).slice(0, 10);
                }
            } else {
                // Real HTTP request
                const response = await fetch(`${this.searchUrl}?search=${encodeURIComponent(searchTerm)}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                data = await response.json();
            }

            this.displayResults(data);
        } catch (error) {
            console.error('Error fetching results:', error);
            this.displayError();
        }
    }

    displayResults(items) {
        // Create mobile UI if on mobile and not already created
        if (this.isMobile && !this.mobileUICreated) {
            this.createMobileUI();
            this.mobileUICreated = true;
            // Schedule results to show after animation completes
            setTimeout(() => {
                // Ensure we're using the correct mobile results container
                if (this.mobileResultsContainer) {
                    this.resultsContainer = this.mobileResultsContainer;
                }
                this.processResults(items);
            }, 400);
            return;
        }

        this.processResults(items);
    }

    processResults(items) {
        // Ensure we're using the correct container
        if (this.isMobile && this.mobileUICreated && this.mobileResultsContainer) {
            this.resultsContainer = this.mobileResultsContainer;
            // For mobile, just clear the content without calling closeAllLists
            this.resultsContainer.innerHTML = '';
        } else {
            // For desktop, use normal close behavior
            this.closeAllLists();
        }

        if (!items || items.length === 0) {
            this.resultsContainer.innerHTML = `<div class="p-3 text-muted">${this.texts.noResults}</div>`;
            this.resultsContainer.classList.add('bg-white', 'border', 'rounded');
            return;
        }

        this.resultsContainer.classList.add('bg-white', 'border', 'rounded');

        // Add mobile-specific class
        if (this.isMobile) {
            this.resultsContainer.classList.add('autocomplete-mobile-list');
        }

        // Add show class to indicate dropdown is open
        this.resultsContainer.classList.add('show');

        // Double-check container reference for mobile
        if (this.isMobile && this.mobileUICreated && this.mobileResultsContainer) {
            this.resultsContainer = this.mobileResultsContainer;
        }

        // Group items by category
        const grouped = this.groupByCategory(items);

        // Display grouped results
        Object.entries(grouped).forEach(([category, categoryItems]) => {
            // Create category header
            if (category != ' ') {
                const categoryHeader = document.createElement('div');
                categoryHeader.classList.add('autocomplete-category-header');
                categoryHeader.textContent = category;
                this.resultsContainer.appendChild(categoryHeader);
            }

            // Add items in this category
            categoryItems.forEach((item, index) => {
                const div = document.createElement('div');
                div.classList.add('autocomplete-item');

                if (!this.isMobile) {
                    div.classList.add('border-bottom');
                    div.classList.add('p-2');
                } else {
                    // More padding for mobile for better touch targets and readability
                    div.classList.add('p-3');
                }

                const searchTerm = this.isMobile && this.mobileSearchInput ?
                    this.mobileSearchInput.value : this.input.value;

                div.innerHTML = this.highlightMatch(item.name || item.title || item.label, searchTerm);
                div.dataset.value = item.id || item.value;
                div.dataset.label = item.name || item.title || item.label;

                div.addEventListener('click', () => {
                    this.selectItem(div.dataset.value, div.dataset.label);
                });

                this.resultsContainer.appendChild(div);
            });
        });
    }

    highlightMatch(text, searchTerm) {
        if (!searchTerm || searchTerm.trim() === '') {
            return text;
        }
        // Escape special regex characters in search term
        const escapedTerm = searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const regex = new RegExp(`(${escapedTerm})`, 'gi');
        return text.replace(regex, '<strong>$1</strong>');
    }

    displayError() {
        this.closeAllLists();
        this.resultsContainer.innerHTML = `<div class="p-3 text-danger">${this.texts.errorLoading}</div>`;
        this.resultsContainer.classList.add('bg-white', 'border', 'rounded');
    }

    selectItem(value, label) {
        // In simple dropdown mode, just update the value without complex behavior
        if (this.simpleDropdown) {
            this.input.value = label;

            // Set the ID in the hidden input
            if (this.hiddenInput) {
                this.hiddenInput.value = value;
                this.hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
            }

            // Update stored values
            this.lastSelectedValue = value;
            this.lastSelectedLabel = label;
            this.dropdownWasOpenedForSelection = false; // Selection made, no need to restore
            this.hasUserTyped = false; // Reset typing flag after selection

            // Close the dropdown
            if (this.isMobile) {
                this.closeMobileUI();
            } else {
                this.closeAllLists();
            }

            // Trigger custom event
            this.input.dispatchEvent(new CustomEvent('autocomplete-select', {
                detail: { value, label }
            }));

            return;
        }

        if (this.isMultiselect && !this.forceSingleSelect) {
            this.addSelectedItem(value, label);

            if (this.persistentDropdown) {
                // Clear search input but keep dropdown open
                this.input.value = '';
                if (this.mobileSearchInput) {
                    this.mobileSearchInput.value = '';
                }
                // Refresh results with empty search
                this.fetchResults('');
            } else {
                this.closeAllLists();
            }
        } else if (this.isMultiselect && this.forceSingleSelect) {
            // Single select mode using multiselect code
            // Clear any existing selections
            this.selectedItems = [];

            // Add the new selection
            this.selectedItems.push({ value, label });

            // Update the input field with the selected value
            this.input.value = label;

            // Update hidden input
            if (this.hiddenInput) {
                this.hiddenInput.value = value;
                this.hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
            }

            // Update stored values for forceSingleSelect
            this.lastSelectedValue = value;
            this.lastSelectedLabel = label;
            this.dropdownWasOpenedForSelection = false;
            this.hasUserTyped = false;

            // Close the dropdown - for mobile single select, close entire UI
            if (this.isMobile) {
                this.closeMobileUI();
            } else {
                this.closeAllLists();
            }

            // Trigger custom event
            this.input.dispatchEvent(new CustomEvent('autocomplete-select', {
                detail: { value, label }
            }));
        } else {
            this.input.value = label;

            // Set the ID in the hidden input
            if (this.hiddenInput) {
                this.hiddenInput.value = value;
                this.hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
            }

            // Update stored values for single select
            this.lastSelectedValue = value;
            this.lastSelectedLabel = label;
            this.dropdownWasOpenedForSelection = false;
            this.hasUserTyped = false;

            // Close the dropdown - for mobile, close entire UI
            if (this.isMobile) {
                this.closeMobileUI();
            } else {
                this.closeAllLists();
            }

            // Display selected item info
            const selectedDiv = document.getElementById('selectedItem');
            if (selectedDiv) {
                selectedDiv.innerHTML = `
                    <div class="alert alert-success">
                        <strong>Selected:</strong> ${label} (ID: ${value})
                    </div>
                `;
            }

            // Trigger custom event
            this.input.dispatchEvent(new CustomEvent('autocomplete-select', {
                detail: { value, label }
            }));
        }
    }

    handleKeydown(e) {
        const items = this.resultsContainer.getElementsByClassName('autocomplete-item');

        if (e.keyCode === 40) { // Arrow DOWN
            e.preventDefault();
            this.currentFocus++;
            this.addActive(items);
        } else if (e.keyCode === 38) { // Arrow UP
            e.preventDefault();
            this.currentFocus--;
            this.addActive(items);
        } else if (e.keyCode === 13) { // Enter
            e.preventDefault();
            if (this.currentFocus > -1 && items[this.currentFocus]) {
                items[this.currentFocus].click();
            }
        } else if (e.keyCode === 27) { // Escape
            this.closeAllLists();
        }
    }

    addActive(items) {
        if (!items) return;

        this.removeActive(items);

        if (this.currentFocus >= items.length) this.currentFocus = 0;
        if (this.currentFocus < 0) this.currentFocus = items.length - 1;

        if (items[this.currentFocus]) {
            items[this.currentFocus].classList.add('active');
        }
    }

    removeActive(items) {
        for (let i = 0; i < items.length; i++) {
            items[i].classList.remove('active');
        }
    }

    handleClickOutside(e) {
        // Check if click is on input, results, mobile search input, or mobile wrapper
        const isInputClick = e.target === this.input;
        const isMobileInputClick = this.mobileSearchInput && e.target === this.mobileSearchInput;
        const isResultsClick = this.resultsContainer.contains(e.target);
        const isMobileWrapperClick = this.mobileWrapper && this.mobileWrapper.contains(e.target);
        const isSelectedContainerClick = this.selectedContainer && this.selectedContainer.contains(e.target);
        const isInlineSelectedClick = this.inlineSelectedContainer && this.inlineSelectedContainer.contains(e.target);

        if (!isInputClick && !isMobileInputClick && !isResultsClick && !isMobileWrapperClick && !isSelectedContainerClick && !isInlineSelectedClick) {
            // In simple dropdown OR single select mode (including forceSingleSelect), restore previous value if dropdown was open
            if ((this.simpleDropdown || (!this.isMultiselect && !this.persistentDropdown) || (this.isMultiselect && this.forceSingleSelect)) && this.dropdownWasOpenedForSelection) {
                this.restorePreviousValue();
                this.dropdownWasOpenedForSelection = false;
                this.hasUserTyped = false;
            }
            this.closeAllLists();
        }
    }

    closeAllLists() {
        // For mobile, check if we should close completely or just clear
        if (this.isMobile && this.mobileUICreated) {
            // Only clear content for mobile, don't close UI unless explicitly needed
            this.clearMobileResults();
            return;
        }

        // Desktop behavior - restore original results container
        if (this.mobileResultsContainer && this.resultsContainer === this.mobileResultsContainer) {
            this.resultsContainer = this.originalResultsContainer;
        }

        this.resultsContainer.innerHTML = '';
        this.resultsContainer.classList.remove('bg-white', 'border', 'rounded', 'autocomplete-mobile-list', 'show');
        this.currentFocus = -1;

    }

    clearMobileResults() {
        // Just clear mobile results content, keep UI open
        if (this.mobileResultsContainer) {
            this.mobileResultsContainer.innerHTML = '';
            this.mobileResultsContainer.classList.remove('bg-white', 'border', 'rounded', 'autocomplete-mobile-list', 'show');
        }
        this.currentFocus = -1;
    }

    closeMobileUI() {
        // In simple dropdown mode, restore previous value if no selection was made
        if (this.simpleDropdown && this.dropdownWasOpenedForSelection) {
            this.restorePreviousValue();
            this.dropdownWasOpenedForSelection = false;
        }

        // Restore original results container
        if (this.mobileResultsContainer && this.resultsContainer === this.mobileResultsContainer) {
            this.resultsContainer = this.originalResultsContainer;
        }

        this.resultsContainer.innerHTML = '';
        this.resultsContainer.classList.remove('bg-white', 'border', 'rounded', 'autocomplete-mobile-list', 'show');
        this.currentFocus = -1;

        // Remove mobile UI
        if (this.backdrop) {
            this.backdrop.classList.remove('show');
            setTimeout(() => {
                if (this.backdrop) {
                    this.backdrop.remove();
                    this.backdrop = null;
                }
            }, 300);
        }
        if (this.mobileWrapper) {
            this.mobileWrapper.classList.remove('show');
            setTimeout(() => {
                if (this.mobileWrapper) {
                    this.mobileWrapper.remove();
                    this.mobileWrapper = null;
                    this.mobileHeader = null;
                    this.mobileResultsContainer = null;
                }
            }, 300);
        }

        // Re-enable body scroll
        if (this.isMobile) {
            document.body.style.overflow = '';
        }

        // Reset mobile UI flag
        this.mobileUICreated = false;
        this.mobileSearchInput = null;
        this.mobileResultsShown = false;
    }

    // Mobile-specific methods
    handleResultsTouchStart(e) {
        this.touchStartY = e.touches[0].clientY;
    }

    handleResultsTouchMove(e) {
        // Prevent page scroll when scrolling results
        const touch = e.touches[0];
        const deltaY = touch.clientY - this.touchStartY;

        if (Math.abs(deltaY) > 5) {
            e.stopPropagation();
        }
    }

    createMobileUI() {
        // Create backdrop
        if (!this.backdrop) {
            this.backdrop = document.createElement('div');
            this.backdrop.className = 'autocomplete-backdrop';
            this.backdrop.addEventListener('click', () => {
                // For simple dropdown, this is considered closing without selection
                if (this.simpleDropdown) {
                    this.dropdownWasOpenedForSelection = true;
                }
                this.closeMobileUI();
            });
            document.body.appendChild(this.backdrop);
        }

        // Create wrapper container
        if (!this.mobileWrapper) {
            this.mobileWrapper = document.createElement('div');
            this.mobileWrapper.className = 'autocomplete-mobile-wrapper';

            // Create header with search input
            this.mobileHeader = document.createElement('div');
            this.mobileHeader.className = 'autocomplete-mobile-header';
            
            // Check if we should show search bar (only for dropdown mode with 10+ items)
            const shouldShowSearch = !this.simpleDropdown || this.localOptions.length >= 10;
            
            this.mobileHeader.innerHTML = `
                <div class="mobile-header-content">
                    <div class="d-flex justify-content-between align-items-center p-3 border-bottom">
                        <h5 class="mb-0">${this.texts.mobileTitle}</h5>
                        <button type="button" class="btn-close" aria-label="${this.texts.close}"></button>
                    </div>
                    ${shouldShowSearch ? `
                    <div class="p-3">
                        <input type="text" class="form-control mobile-search-input" placeholder="${this.texts.search}" autocomplete="off">
                    </div>
                    ` : ''}
                </div>
            `;

            const closeBtn = this.mobileHeader.querySelector('.btn-close');
            closeBtn.addEventListener('click', () => {
                // For simple dropdown, this is considered closing without selection
                if (this.simpleDropdown) {
                    this.dropdownWasOpenedForSelection = true;
                }
                this.closeMobileUI();
            });

            // Set up mobile search input (only if it exists)
            this.mobileSearchInput = this.mobileHeader.querySelector('.mobile-search-input');

            if (this.mobileSearchInput) {
                // Prevent mobile search input focus from triggering main focus handler
                this.mobileSearchInput.addEventListener('focus', (e) => {
                    e.stopPropagation();
                });

                this.mobileSearchInput.addEventListener('input', (e) => {
                // Mark that user has typed
                this.hasUserTyped = true;

                const value = e.target.value;

                // Simple dropdown mode - filter locally on mobile too
                if (this.simpleDropdown) {
                    if (value.length === 0) {
                        this.processResults(this.localOptions);
                    } else {
                        const filtered = this.filterLocalOptions(value);
                        this.processResults(filtered);
                    }
                    return;
                }

                clearTimeout(this.debounceTimer);

                if (value.length === 0 && this.prefilledOptions) {
                    // Show prefilled options if user clears mobile input
                    this.processResults(this.prefilledOptions);
                } else {
                    this.debounceTimer = setTimeout(() => {
                        this.fetchResults(value);
                    }, this.debounceDelay);
                }
            });
            }

            // Move results container into wrapper
            const resultsClone = this.resultsContainer.cloneNode(true);
            resultsClone.id = this.resultsContainer.id + '-mobile';
            resultsClone.classList.add('autocomplete-mobile-list');
            this.mobileResultsContainer = resultsClone;

            // Append header, inline selected items (if persistent), and results to wrapper
            this.mobileWrapper.appendChild(this.mobileHeader);

            if (this.persistentDropdown && this.inlineSelectedContainer) {
                this.mobileWrapper.appendChild(this.inlineSelectedContainer);
            }

            this.mobileWrapper.appendChild(this.mobileResultsContainer);

            document.body.appendChild(this.mobileWrapper);

            // Copy current search value to mobile input but don't focus
            setTimeout(() => {
                if (this.mobileSearchInput) {
                    // For simple dropdown, don't copy the value (let it be empty for search)
                    if (!this.simpleDropdown && this.input.value) {
                        this.mobileSearchInput.value = this.input.value;
                    }
                    // Don't auto-focus to prevent keyboard from opening
                    // this.mobileSearchInput.focus();
                }
            }, 350);
        }

        // Use mobile results container for mobile display
        this.resultsContainer = this.mobileResultsContainer;

        // Prevent body scroll
        document.body.style.overflow = 'hidden';

        // Trigger animation
        setTimeout(() => {
            this.backdrop.classList.add('show');
            this.mobileWrapper.classList.add('show');
        }, 10);
    }

    groupByCategory(items) {
        const grouped = {};

        items.forEach(item => {
            const category = item.category || 'Other';
            if (!grouped[category]) {
                grouped[category] = [];
            }
            grouped[category].push(item);
        });

        // Sort categories to have 'Popular' or similar first
        const sortedGrouped = {};
        const sortedKeys = Object.keys(grouped).sort((a, b) => {
            if (a.toLowerCase().includes('popular')) return -1;
            if (b.toLowerCase().includes('popular')) return 1;
            return a.localeCompare(b);
        });

        sortedKeys.forEach(key => {
            sortedGrouped[key] = grouped[key];
        });

        return grouped;
    }

    setupMultiselect() {
        if (this.persistentDropdown) {
            // For persistent dropdown, create inline container that will show in mobile between search and results
            this.inlineSelectedContainer = document.createElement('div');
            this.inlineSelectedContainer.className = 'autocomplete-inline-selected';

            // Also create a desktop container that shows when panel is closed
            this.selectedContainer = document.createElement('div');
            this.selectedContainer.className = 'autocomplete-selected-items persistent-selected';
            this.input.parentNode.insertBefore(this.selectedContainer, this.input.nextSibling);
        } else {
            // Create container for selected items below input (original behavior)
            this.selectedContainer = document.createElement('div');
            this.selectedContainer.className = 'autocomplete-selected-items';
            this.input.parentNode.insertBefore(this.selectedContainer, this.input.nextSibling);
        }
    }

    addSelectedItem(value, label) {
        // Check if already selected
        if (this.selectedItems.find(item => item.value === value)) {
            return;
        }

        const selectedItem = { value, label };
        this.selectedItems.push(selectedItem);

        if (this.persistentDropdown) {
            this.updateInlineSelectedItems();
            this.updateDesktopSelectedItems();
        } else {
            // Original behavior - create visual element in selected container
            const itemElement = document.createElement('div');
            itemElement.className = 'selected-item';
            itemElement.innerHTML = `
                <span class="selected-item-label">${label}</span>
                <button type="button" class="selected-item-remove" data-value="${value}">&times;</button>
            `;

            // Add remove functionality
            const removeBtn = itemElement.querySelector('.selected-item-remove');
            removeBtn.addEventListener('click', () => {
                this.removeSelectedItem(value);
            });

            this.selectedContainer.appendChild(itemElement);
        }

        // Update hidden inputs - create separate input for each selected item
        this.updateHiddenInputs();

        // Don't clear search input here for persistent dropdown - handled in selectItem
        if (!this.persistentDropdown) {
            this.input.value = '';
        }

        // Trigger custom event
        this.input.dispatchEvent(new CustomEvent('autocomplete-multiselect', {
            detail: { selectedItems: this.selectedItems, added: selectedItem }
        }));
    }

    removeSelectedItem(value) {
        this.selectedItems = this.selectedItems.filter(item => item.value !== value);

        if (this.persistentDropdown) {
            this.updateInlineSelectedItems();
            this.updateDesktopSelectedItems();
        } else {
            // Remove visual element
            const itemElement = this.selectedContainer.querySelector(`[data-value="${value}"]`).parentNode;
            itemElement.remove();
        }

        // Update hidden inputs - create separate input for each selected item
        this.updateHiddenInputs();

        // Trigger custom event
        this.input.dispatchEvent(new CustomEvent('autocomplete-multiselect', {
            detail: { selectedItems: this.selectedItems, removed: value }
        }));
    }

    updateInlineSelectedItems() {
        if (!this.inlineSelectedContainer) return;

        this.inlineSelectedContainer.innerHTML = '';

        if (this.selectedItems.length === 0) {
            this.inlineSelectedContainer.style.display = 'none';
            return;
        }

        this.inlineSelectedContainer.style.display = 'block';

        // Show first few items, then collapse if too many
        const maxVisible = 3;

        if (this.selectedItems.length <= maxVisible || !this.selectedCollapsed) {
            // Show all items or expanded view
            this.selectedItems.forEach(item => {
                const chip = document.createElement('span');
                chip.className = 'inline-selected-chip';
                chip.innerHTML = `
                    ${item.label}
                    <button type="button" class="chip-remove" data-value="${item.value}">&times;</button>
                `;

                const removeBtn = chip.querySelector('.chip-remove');
                removeBtn.addEventListener('click', (e) => {
                    e.stopPropagation();
                    this.removeSelectedItem(item.value);
                });

                this.inlineSelectedContainer.appendChild(chip);
            });

            // Add collapse button if more than maxVisible
            if (this.selectedItems.length > maxVisible) {
                const collapseBtn = document.createElement('button');
                collapseBtn.className = 'selected-collapse-btn';
                collapseBtn.textContent = 'Show less';
                collapseBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.selectedCollapsed = true;
                    this.updateInlineSelectedItems();
                });
                this.inlineSelectedContainer.appendChild(collapseBtn);
            }
        } else {
            // Collapsed view - show count
            const summary = document.createElement('div');
            summary.className = 'selected-summary';
            summary.innerHTML = `
                <span>${this.selectedItems.length} items selected</span>
                <button type="button" class="selected-expand-btn">Show all</button>
            `;

            const expandBtn = summary.querySelector('.selected-expand-btn');
            expandBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.selectedCollapsed = false;
                this.updateInlineSelectedItems();
            });

            this.inlineSelectedContainer.appendChild(summary);
        }
    }

    updateDesktopSelectedItems() {
        if (!this.selectedContainer || !this.persistentDropdown) return;

        this.selectedContainer.innerHTML = '';

        if (this.selectedItems.length === 0) {
            this.selectedContainer.style.display = 'none';
            return;
        }

        this.selectedContainer.style.display = 'block';

        // Show selected items as chips similar to mobile but in desktop style
        this.selectedItems.forEach(item => {
            const itemElement = document.createElement('div');
            itemElement.className = 'selected-item desktop-chip';
            itemElement.innerHTML = `
                <span class="selected-item-label">${item.label}</span>
                <button type="button" class="selected-item-remove" data-value="${item.value}">&times;</button>
            `;

            // Add remove functionality
            const removeBtn = itemElement.querySelector('.selected-item-remove');
            removeBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.removeSelectedItem(item.value);
            });

            this.selectedContainer.appendChild(itemElement);
        });
    }

    updateHiddenInputs() {
        if (!this.hiddenInput || !this.isMultiselect) {
            // For single select, just set the value normally
            if (this.hiddenInput && !this.isMultiselect && this.selectedItems.length > 0) {
                this.hiddenInput.value = this.selectedItems[0].value;
                this.hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
            return;
        }

        // Remove all existing hidden inputs for this autocomplete
        const hiddenInputName = this.hiddenInput.name || this.hiddenInput.id;
        const existingInputs = document.querySelectorAll(`input[name="${hiddenInputName}[]"]`);
        existingInputs.forEach(input => input.remove());

        // Create new hidden input for each selected item
        this.selectedItems.forEach(item => {
            const hiddenInput = document.createElement('input');
            hiddenInput.type = 'hidden';
            hiddenInput.name = `${hiddenInputName}[]`;
            hiddenInput.value = item.value;

            // Insert after the original hidden input
            this.hiddenInput.parentNode.insertBefore(hiddenInput, this.hiddenInput.nextSibling);
        });
    }
}